import React from 'react'
import { FiMoon, FiSun } from 'react-icons/fi'
import { useLocation } from 'react-router-dom'

const Header = ({isDark,setIsDark}) => {
  const location = useLocation()
  const currentpath = location?.pathname


  return (
   <>

   <header className="topbar">
          {/* <div>
            <h1 className="topbar-title">API Monitoring - {currentpath==="/test-env"?"TEST" : currentpath==="/dev-env" ? "DEV": currentpath === "/san-env"? "SAN":"ENV Missing"} </h1>
            <p className="topbar-subtitle">Real-time endpoint monitoring</p>
          </div> */}
         <button
      className={`dark-toggle ${isDark ? "dark" : "light"}`}
    onClick={() => setIsDark((prev) => !prev)}
    >
  {/* <div className="toggle-track">
    <div className="toggle-thumb"></div>

    <FiSun className="toggle-icon sun" size={16} />
    <FiMoon className="toggle-icon moon" size={16} />
  </div> */}
</button>
        </header>
   </>
  )
}

export default Header